module.exports = __webpack_public_path__ + "static/media/vis13.826eadb7.jpeg";